import { useSyncExternalStore } from "react";
import { getRecords, subscribe } from "@/store/recordsStore";

export function useRecords() {
  return useSyncExternalStore(subscribe, getRecords, getRecords);
}